import React, { VFC } from 'react'

import styled, { css } from 'styled-components'

import { Modal } from 'src/components/atoms'

import { useStaticPage } from 'src/hooks'
import { mediaQuery } from 'src/responsive'

const LaptopContainer = css`
  min-width: 72rem;
`
const Container = styled.div`
  max-width: 96rem;
  height: 84vh;
  border-radius: 0.8rem;
  padding: 24px 40px 40px;
  max-height: inherit;

  &::before {
    content: '';
    position: absolute;
    left: 40px;
    right: 40px;
    top: 24px;
    height: 40px;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.009) 6.67%,
      rgba(255, 255, 255, 0.036) 13.33%,
      rgba(255, 255, 255, 0.082) 20%,
      rgba(255, 255, 255, 0.147) 26.67%,
      rgba(255, 255, 255, 0.232) 33.33%,
      rgba(255, 255, 255, 0.332) 40%,
      rgba(255, 255, 255, 0.443) 46.67%,
      rgba(255, 255, 255, 0.557) 53.33%,
      rgba(255, 255, 255, 0.668) 60%,
      rgba(255, 255, 255, 0.768) 66.67%,
      rgba(255, 255, 255, 0.853) 73.33%,
      rgba(255, 255, 255, 0.918) 80%,
      rgba(255, 255, 255, 0.964) 86.67%,
      rgba(255, 255, 255, 0.991) 93.33%,
      #fff 100%
    );
  }

  &::after {
    content: '';
    position: absolute;
    left: 40px;
    right: 40px;
    bottom: 40px;
    height: 40px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.009) 6.67%,
      rgba(255, 255, 255, 0.036) 13.33%,
      rgba(255, 255, 255, 0.082) 20%,
      rgba(255, 255, 255, 0.147) 26.67%,
      rgba(255, 255, 255, 0.232) 33.33%,
      rgba(255, 255, 255, 0.332) 40%,
      rgba(255, 255, 255, 0.443) 46.67%,
      rgba(255, 255, 255, 0.557) 53.33%,
      rgba(255, 255, 255, 0.668) 60%,
      rgba(255, 255, 255, 0.768) 66.67%,
      rgba(255, 255, 255, 0.853) 73.33%,
      rgba(255, 255, 255, 0.918) 80%,
      rgba(255, 255, 255, 0.964) 86.67%,
      rgba(255, 255, 255, 0.991) 93.33%,
      #fff 100%
    );
  }

  ${mediaQuery.greaterLaptop`
    ${LaptopContainer}
  `}
`

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const UsageEnvironmentModal: VFC<Props> = ({ isOpen, onClose }) => {
  const { usageEnvironmentPageUrl } = useStaticPage()

  return (
    <Modal isOpen={isOpen} maxWidth="xs" onClose={onClose}>
      <Container className="tw-bg-surface-primary">
        {/* 利用環境はiframeで用意されたページを表示 */}
        <iframe title="利用環境" src={usageEnvironmentPageUrl} className="tw-w-full tw-h-full" />
      </Container>
    </Modal>
  )
}
